import { render, staticRenderFns } from "./IdeiaVideo.vue?vue&type=template&id=1a6d0944&scoped=true&"
import script from "./IdeiaVideo.vue?vue&type=script&lang=js&"
export * from "./IdeiaVideo.vue?vue&type=script&lang=js&"
import style0 from "./IdeiaVideo.vue?vue&type=style&index=0&id=1a6d0944&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6d0944",
  null
  
)

export default component.exports